<template>
  <table class="prop-table mb-2">
    <tr>
      <th>Participant amount</th>
      <td>{{stat.participantAmount | getFormattedNumber}}</td>
    </tr>
  </table>
</template>

<script>
export default {
  name: 'TmntGvntStat',

  props: {
    stat: {
      type: Object,
      required: true,
    },
  },
};
</script>
